import { useEffect, useRef, useState } from 'react';
export default function useEfImportacao(resultados, carregar) {
 const [dados,setDados]=useState({});
 const cache=useRef({});
 const ids=[...new Set(resultados.filter(r=>r.despesa_id && !['pending','processing','erro'].includes(r.status)).map(r=>Number(r.despesa_id)))].sort((a,b)=>a-b).join(',');
 useEffect(()=>{
  let cancelado=false,timer;
  const lista=ids?ids.split(',').map(Number):[];
  async function atualizar(){
   if(!carregar || !lista.length)return;
   if(document.hidden){timer=setTimeout(atualizar,3000);return;}
   const pendentes=lista.filter(id=>!cache.current[id] || cache.current[id].sugestao_ef?.estado==='pendente');
   if(!pendentes.length)return;
   try {
    const recebidos=await carregar(pendentes);
    if(cancelado)return;
    const mapa=new Map(recebidos.map(r=>[Number(r.id),r]));
    for(const id of pendentes)cache.current[id]=mapa.get(id)||{erro:true};
   } catch {if(cancelado)return;for(const id of pendentes)cache.current[id]={erro:true};}
   setDados({...cache.current});
   timer=setTimeout(atualizar,3000);
  }
  atualizar();
  return ()=>{cancelado=true;clearTimeout(timer);};
 },[ids,carregar]);
 return dados;
}